module.exports = __webpack_public_path__ + "media/src/assets/Images/PlusIcon-422e9b06bf397823c8546291eb8b9c84.svg";